import SellerMarketplaceCard from './components/SellerOfferCard';

import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Card from 'components/card';
import { useNavigate } from 'react-router-dom';
import { getImage } from 'variables/images';
import SignUpModal from '../../buyer/sellerOffer/components/SignUpModal';

const BuyerOffer = () => {
    const [offers, setOffers] = useState([]);
    const [user, setUser] = useState(null);
    const [isURLLoading, setIsURLLoading] = useState(false);
    const [isLandingConnected, setIsLandingConnected] = useState(true);
    const [selectedSubIndustry, setSelectedSubIndustry] = useState('all');
    const [selectedPriceRange, setSelectedPriceRange] = useState('all');
    const [selectedLeadRange, setSelectedLeadRange] = useState('all');
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [purchaseOrderVolumes, setPurchaseOrderVolumes] = useState([]);
    const nav = useNavigate();

    // Guest user detection
    const isGuest = user?.email?.includes('guest-') ?? false;

    const priceRanges = [
        { value: 'all', label: 'Tous' },
        { value: '0-10', label: '0 - 10€' },
        { value: '10-20', label: '10 - 20€' },
        { value: '20-50', label: '20 - 50€' },
        { value: '50+', label: '50€ +' },
    ];

    const leadRanges = [
        { value: 'all', label: 'Tous' },
        { value: '0-50', label: '0 - 50' },
        { value: '50-200', label: '50 - 200' },
        { value: '200-500', label: '200 - 500' },
        { value: '500+', label: '500 +' },
    ];

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/admin/dashboard';
                } else if (res.data && !res.data.isAlreadyConnected) {
                    setIsLandingConnected(false);
                }
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initOffer = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer`, config)
            .then((res) => {
                setOffers(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initPurchaseOrderVolumes = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/purchase-order/volumes`, config)
            .then((res) => {
                setPurchaseOrderVolumes(res.data);
                console.log('Purchase order volumes:', res.data);
            })
            .catch((err) => {
                console.log('Error fetching purchase order volumes', err);
            });
    };

    const startKYCProcess = () => {
        setIsURLLoading(true);
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/stripe/kyc`, config)
            .then((res) => {
                console.log(res.data);
                window.location.href = res.data.url;
            })
            .catch((err) => {
                console.log('Impossible to prepare KYC process', err);
            });
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        initOffer();
        initUser();
        initPurchaseOrderVolumes();
    }, []);

    const marketOffers = offers.filter((o) => o.status === 'on_market');

    const subIndustries = useMemo(() => {
        const unique = [...new Set(marketOffers.map((o) => o.subIndustry).filter(Boolean))];
        return unique.sort();
    }, [marketOffers]);

    const getMinRealPrice = (offer: any) => {
        const values = offer.targetPrice.replace('€', '').split('-');
        return Number(values[0]) * 0.9 - offer.fixedMargin;
    };

    const filteredOffers = marketOffers.filter((o) => {
        if (selectedSubIndustry !== 'all' && o.subIndustry !== selectedSubIndustry) return false;
        if (selectedPriceRange !== 'all') {
            const minPrice = getMinRealPrice(o);
            if (selectedPriceRange === '50+') {
                if (minPrice < 50) return false;
            } else {
                const [low, high] = selectedPriceRange.split('-').map(Number);
                if (minPrice < low || minPrice >= high) return false;
            }
        }
        if (selectedLeadRange !== 'all') {
            const qty = o.weeklyQuantity || 0;
            if (selectedLeadRange === '500+') {
                if (qty < 500) return false;
            } else {
                const [low, high] = selectedLeadRange.split('-').map(Number);
                if (qty < low || qty >= high) return false;
            }
        }
        return true;
    });

    const displayRealPrice = (price: string, fixedMargin: number) => {
        const values = price.replace('€', '').split('-');
        const min = Number(values[0]);
        const max = Number(values[1]);
        return `${min * 0.9 - fixedMargin}-${max * 0.9 - fixedMargin}`;
    };

    const DiscoverCommandPage = () => {
        return (
            <div className="w-full rounded-[20px] border border-gray-200/50 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-8 shadow-lg dark:border-white/10 dark:from-navy-800 dark:to-navy-900">
                <div className="flex items-center justify-between gap-8">
                    <div className="flex-1 pr-4">
                        <h2 className="text-[28px] font-bold leading-tight text-gray-900 dark:text-white">
                            Marketplace 🎉
                        </h2>
                        <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                            Vous pouvez consulter l'ensemble des demandes des acheteurs et vous positionner sur celles qui correspondent à vos leads. Sélectionnez les demandes pertinentes, soumettez vos offres et vendez vos leads aux acheteurs intéressés.
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    const PurchaseOrderVolumes = () => {
        if (!purchaseOrderVolumes || purchaseOrderVolumes.length === 0) {
            return null;
        }

        const totalLeads = purchaseOrderVolumes.reduce((sum, vol) => sum + vol.totalLeads, 0);

        return (
            <Card
                extra={
                    'w-full p-6 mt-4 shadow-3xl shadow-shadow-500 rounded-[20px] dark:!bg-navy-800 dark:shadow-none'
                }
            >
                <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                        📦 Ordres d'achat ouverts
                    </h3>
                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                        Les acheteurs recherchent actuellement{' '}
                        <span className="font-bold text-[#10b981]">{totalLeads.toLocaleString('fr-FR')}</span>{' '}
                        leads dans les secteurs suivants
                    </p>
                </div>
                
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {purchaseOrderVolumes.map((volume) => {
                        // Format departments for display
                        const departments = volume.departments || [];
                        const visibleDepts = departments;
                        const remainingCount = 0;
                        const allDeptsText = departments.join(', ');

                        return (
                            <div
                                key={volume.subIndustry}
                                className="group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200/80 bg-gradient-to-br from-white to-gray-50/50 p-5 transition-all duration-300 hover:border-[#10b981]/40 hover:shadow-xl hover:shadow-[#10b981]/5 hover:-translate-y-0.5 dark:border-white/10 dark:from-navy-700 dark:to-navy-800"
                            >
                                {/* Header with title and order count */}
                                <div className="mb-4 flex items-start justify-between gap-3">
                                    <div className="flex-1 min-w-0">
                                        <h4 className="text-sm font-bold text-gray-900 dark:text-white line-clamp-2 leading-snug capitalize">
                                            {volume.subIndustry?.replace(/-/g, ' ') || 'Autres secteurs'}
                                        </h4>
                                    </div>
                                </div>

                                {/* Regions as badges */}
                                {departments.length > 0 && (
                                    <div className="mb-4 flex flex-wrap gap-1.5">
                                        {visibleDepts.map((dept: string, idx: number) => (
                                            <span
                                                key={idx}
                                                className="inline-flex items-center rounded-md bg-gray-100/80 px-2 py-0.5 text-xs font-medium text-gray-700 dark:bg-navy-600 dark:text-gray-300"
                                            >
                                                {dept}
                                            </span>
                                        ))}
                                        {remainingCount > 0 && (
                                            <span
                                                className="inline-flex items-center rounded-md bg-gray-200/80 px-2 py-0.5 text-xs font-semibold text-gray-600 cursor-help dark:bg-navy-600 dark:text-gray-300"
                                                title={allDeptsText}
                                            >
                                                +{remainingCount}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {departments.length === 0 && (
                                    <div className="mb-4">
                                        <span className="inline-flex items-center gap-1 rounded-md bg-blue-50/80 px-2.5 py-1 text-xs font-medium text-blue-700 dark:bg-blue-900/20 dark:text-blue-300">
                                            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            Toutes régions
                                        </span>
                                    </div>
                                )}

                                {/* Lead count - Hero element */}
                                <div className="mt-auto">
                                    <div className="flex items-end justify-between">
                                        <div className="flex items-baseline gap-2">
                                            <span className="text-3xl font-bold tracking-tight text-[#10b981] group-hover:text-[#0d9668] transition-colors">
                                                {volume.totalLeads.toLocaleString('fr-FR')}
                                            </span>
                                            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                                leads
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Subtle gradient overlay on hover */}
                                <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#10b981]/0 to-[#10b981]/0 group-hover:from-[#10b981]/5 group-hover:to-transparent transition-all duration-300 rounded-2xl" />
                            </div>
                        );
                    })}
                </div>
            </Card>
        );
    };

    const WelcomeAndConnectSeller = () => {
        return (
            <Card
                extra={
                    'w-full p-6 h-fit shadow-3xl shadow-shadow-500 rounded-[20px] dark:!bg-navy-800 dark:shadow-none'
                }
            >
                <div className="relative">
                    <p className="text-2xl font-bold text-gray-900 dark:text-white">
                        Bienvenue sur Leadrs
                    </p>
                    <div>
                        <p className="mt-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                            Avec leadrs vous pouvez créez votre offre pour la
                            proposer à des acheteurs ou positionnez vous sur une
                            demande acheteur existante et vendre vos leads en
                            toute tranquilité.
                        </p>
                    </div>
                </div>
            </Card>
        );
    };

    return (
        <div className="h-full w-full rounded-[20px]">
            {user && user.isKYCVerified === false && (
                <div
                    className="relative mb-4 rounded-[20px] border border-red-200 bg-red-50 px-6 py-4 text-sm font-medium text-gray-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-white"
                    role="alert"
                >
                    <span className="block sm:inline">Vous devez </span>
                    <span
                        className="block cursor-pointer text-leadrs underline transition duration-200 hover:text-brand-deep sm:inline"
                        onClick={startKYCProcess}
                    >
                        ajouter vos coordonnées bancaires
                    </span>
                    <span className="block sm:inline">
                        {' '}
                        pour pouvoir commencer à vendre. (Utilisez le mail par
                        défaut uniquement)
                    </span>
                    {isURLLoading && (
                        <svg
                            aria-hidden="true"
                            className="ml-2 inline h-4 w-4 animate-spin fill-leadrs text-gray-200 dark:text-gray-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                            />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                            />
                        </svg>
                    )}
                </div>
            )}
            {isLandingConnected ? (
                <DiscoverCommandPage />
            ) : (
                <WelcomeAndConnectSeller />
            )}
            <PurchaseOrderVolumes />
            <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <label className="text-sm font-medium text-gray-600 dark:text-gray-400">
                        Type d'offre :
                    </label>
                    <select
                        className="rounded-xl border border-gray-200 bg-white/0 px-3 py-2 text-sm text-gray-700 transition duration-200 focus:border-leadrs focus:outline-none dark:border-white/10 dark:text-white"
                        value={selectedSubIndustry}
                        onChange={(e) => setSelectedSubIndustry(e.target.value)}
                    >
                        <option value="all">Toutes</option>
                        {subIndustries.map((sub) => (
                            <option key={sub} value={sub}>
                                {sub}
                            </option>
                        ))}
                    </select>
                    <label className="text-sm font-medium text-gray-600 dark:text-gray-400">
                        Prix :
                    </label>
                    <select
                        className="rounded-xl border border-gray-200 bg-white/0 px-3 py-2 text-sm text-gray-700 transition duration-200 focus:border-leadrs focus:outline-none dark:border-white/10 dark:text-white"
                        value={selectedPriceRange}
                        onChange={(e) => setSelectedPriceRange(e.target.value)}
                    >
                        {priceRanges.map((range) => (
                            <option key={range.value} value={range.value}>
                                {range.label}
                            </option>
                        ))}
                    </select>
                    <label className="text-sm font-medium text-gray-600 dark:text-gray-400">
                        Nombre de leads :
                    </label>
                    <select
                        className="rounded-xl border border-gray-200 bg-white/0 px-3 py-2 text-sm text-gray-700 transition duration-200 focus:border-leadrs focus:outline-none dark:border-white/10 dark:text-white"
                        value={selectedLeadRange}
                        onChange={(e) => setSelectedLeadRange(e.target.value)}
                    >
                        {leadRanges.map((range) => (
                            <option key={range.value} value={range.value}>
                                {range.label}
                            </option>
                        ))}
                    </select>
                </div>
                <button
                    className="flex items-center justify-end rounded-xl bg-leadrs px-4 py-2 text-sm font-medium text-white transition duration-200 hover:bg-brand-deep active:bg-brand-deep"
                    onClick={() => nav('/admin/seller-offer')}
                >
                    Ajouter une offre
                </button>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                {filteredOffers.length === 0 &&
                    marketOffers.length === 0 &&
                    [0, 1, 2].map((offer) => {
                        return (
                            <div className="relative rounded-xl border-2">
                                <p className="absolute top-[40%] mx-auto my-auto items-center rounded-2xl bg-gray-200 bg-opacity-70 px-2 py-2 text-center text-sm font-medium">
                                    Cette offre est actuellement en cours de
                                    validation. Elle sera bientôt disponible.
                                </p>
                                <SellerMarketplaceCard
                                    key={offer}
                                    offerNumber="0000"
                                    channels={[]}
                                    extra="blur-sm border-2 -z-10"
                                    title={'Pompe à chaleuree'}
                                    author={'Rénovation énergétique'}
                                    status={'on_market'}
                                    // eslint-disable-next-line eqeqeq
                                    isArchived={false}
                                    price={15}
                                    weeklyQuantity={500}
                                    image={getImage('Assurance', '')}
                                    onClick={() => {}}
                                />
                            </div>
                        );
                    })}
                {filteredOffers.map((offer) => {
                        return (
                            <SellerMarketplaceCard
                                key={offer._id}
                                offerNumber={offer.offerNumber}
                                channels={offer.channels}
                                title={offer.subIndustry}
                                author={offer.industry}
                                status={offer.status}
                                price={displayRealPrice(
                                    offer.targetPrice,
                                    offer.fixedMargin
                                )}
                                image={getImage(
                                    offer.industry,
                                    offer.subIndustry
                                )}
                                weeklyQuantity={offer.weeklyQuantity}
                                isKYCVerified={user && user.isKYCVerified}
                                isValidated={user && user.isValidated}
                                isGuest={isGuest}
                                onGuestClick={() => setShowSignUpModal(true)}
                                onClick={() => {
                                    nav(`/admin/market-offer/${offer._id}`);
                                }}
                            />
                        );
                    })}
            </div>
            <SignUpModal
                isOpen={showSignUpModal}
                onClose={(accountCreated: boolean) => {
                    setShowSignUpModal(false);
                    if (accountCreated) {
                        initUser(); // Refetch user data to reveal prices
                    }
                }}
            />
        </div>
    );
};

export default BuyerOffer;
